import React from "react";
import { Row, Col, Statistic } from "antd";
import { ValimateConfigurationResultDto } from "../../autogenerated/models";

interface TucResultSummaryProps {
  configurationResult: ValimateConfigurationResultDto;
}

const TucResultSummary: React.FC<TucResultSummaryProps> = ({
  configurationResult = {},
}) => {
  const getExecutionStepsSummary = (
    configurationResult: ValimateConfigurationResultDto,
    severity: string
  ) =>
    configurationResult.execution?.callback?.steps
      ?.flatMap((executionStep) => executionStep.constraints)
      .filter((constraint) => constraint?.severity === severity)
      .map((constraint) => constraint?.count)
      .reduce((prev, next) => (prev ?? 0) + (next ?? 0), 0);

  return (
    <Col span={12}>
      <Row>
        <Col span={3}>
          <Statistic
            title="Info"
            value={getExecutionStepsSummary(configurationResult, "info")}
          />
        </Col>
        <Col span={3}>
          <Statistic
            title="Warning"
            value={getExecutionStepsSummary(configurationResult, "warning")}
          />
        </Col>
        <Col span={3}>
          <Statistic
            title="Error"
            value={getExecutionStepsSummary(configurationResult, "error")}
          />
        </Col>
      </Row>
    </Col>
  );
};

export default TucResultSummary;
